import { Component, ChangeDetectionStrategy } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { FieldType, FieldTypeConfig } from "@ngx-formly/core";
import { TranslateModule } from "@ngx-translate/core";
import { CompanyBlacklistInputComponent } from "../company-blacklist-input/company-blacklist-input.component";

/**
 * Formly wrapper around CompanyBlacklistInputComponent.
 *
 * Usage:
 * ```typescript
 * {
 *   key: 'blacklistedCompanies',
 *   type: 'company-blacklist-input',
 *   props: {
 *     label: 'Hide profile from companies',
 *     placeholder: 'Search for a company',
 *   }
 * }
 * ```
 */
@Component({
  selector: "formly-company-blacklist-input",
  standalone: true,
  imports: [ReactiveFormsModule, TranslateModule, CompanyBlacklistInputComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (props.label) {
      <label class="form-label">{{ props.label | translate }}</label>
    }
    <app-company-blacklist-input
      [placeholder]="props.placeholder || 'Search for a company'"
      [formControl]="formControl"
    ></app-company-blacklist-input>
  `,
})
export class CompanyBlacklistInputFieldType extends FieldType<FieldTypeConfig> {}
